import apiFetch from '../apiFetch'

export default function (token, purchasePresentTypeId) {
  return apiFetch({ endPoint: `PurchasePresentType/${purchasePresentTypeId}`, method: 'DELETE', body: null, token: token })
}
